import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingEligibility } from '../editor-booking-item-setting/editor-booking-item-setting-eligibility.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-eligibility',
    templateUrl: './editor-booking-item-setting-value.component.html',
    standalone: false
})
export class EditorBookingItemSettingValueEligibilityComponent implements OnInit {
  @Input() itemSetting: EditorBookingItemSettingEligibility;

  private destroyed$ = new Subject<void>();

  eligibilityRulesNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.eligibilityRulesNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(eligibilityRulesNames => {
        this.eligibilityRulesNames = eligibilityRulesNames;
        this.value = this.getValue();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.eligibilityRulesNames === undefined) {
      return $localize `Not available`;
    }
    return this.itemSetting.getIdAsString(this.eligibilityRulesNames);
  }
}
